import { useContext } from 'react';
import interpolateComponents from 'interpolate-components';
import classNames from 'clsx';
import {
  SUBSCRIBE_AUTO_RENEW_COPY,
  LEARN_MORE_TEXT,
} from 'src/common/constants/localizations/subscription';
import ExternalLink from '../shared/link/ExternalLink';
import getOverrideOrDefaultResourceKey from '../../utils/getOverrideOrDefaultResourceKey';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import css from './payment.module.scss';

const AutoRenewCopy = () => {
  const { getLocalizedText, location } = useContext(
    LocationAndLocalizationContext,
  );

  return (
    <div className="row">
      <div
        className={classNames('col-xs-12', css.description)}
        data-testid="AutoRenewCopy"
      >
        <div className={css.copy}>
          <span data-testid="renewCopy">
            {interpolateComponents({
              mixedString: getLocalizedText(
                getOverrideOrDefaultResourceKey(
                  getLocalizedText,
                  location,
                  SUBSCRIBE_AUTO_RENEW_COPY,
                ),
              ),
              components: {
                linebreak: <br />,
              },
            })}
          </span>
          <ExternalLink
            dataTestId="learnMoreLink"
            href="https://tunein.com/policies/"
            className={css.link}
            tabIndex={-1}
          >
            &nbsp;
            {getLocalizedText(
              getOverrideOrDefaultResourceKey(
                getLocalizedText,
                location,
                LEARN_MORE_TEXT,
              ),
            )}
          </ExternalLink>
        </div>
      </div>
    </div>
  );
};

export default AutoRenewCopy;
